import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Layout from '../components/Layout';
import { useFetchNotices } from '../hooks/useAppInit';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/SingleNotice.css';

export default function SingleNotice() {
  useFetchNotices();
  const { noticeId } = useParams();
  const notices = useSelector((state) => state.notices.notices);
  const notice = notices.find((n) => n._id === noticeId);

  if (!notice) {
    return (
      <Layout bannerTitle="Notice">
        <section className="inner-page-section">
          <div className="container-fluid px-5 text-center py-5">
            <i className="fas fa-bell-slash fa-3x text-muted mb-3 d-block"></i>
            <h4>Notice not found or still loading.</h4>
            <Link to="/noticeall" className="btn btn-primary mt-3">Back to All Notices</Link>
          </div>
        </section>
      </Layout>
    );
  }

  return (
    <Layout bannerTitle={notice.title}>
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Notice Detail" />
          <div className="row justify-content-center mt-4">
            <div className="col-lg-8">
              <div className="single-notice-card">
                <div className="single-notice-header">
                  <span className={`notice-type-badge type-${notice.noticeType?.toLowerCase()}`}>{notice.noticeType}</span>
                  <span className="single-notice-date">
                    <i className="fas fa-calendar me-1"></i>
                    {moment(notice.date || notice.createdAt).format('DD MMMM YYYY')}
                  </span>
                </div>
                <h3 className="single-notice-title">{notice.title}</h3>
                {notice.description && <div className="single-notice-body">{notice.description}</div>}
                {notice.file && (
                  <div className="single-notice-download mt-4">
                    <a href={notice.file} target="_blank" rel="noreferrer" className="download-btn">
                      <i className="fas fa-download me-2"></i>Download Attachment
                    </a>
                  </div>
                )}
                <div className="mt-5">
                  <Link to="/noticeall" className="back-btn">
                    <i className="fas fa-arrow-left me-1"></i> Back to All Notices
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
